export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#F8F5F0] text-[#1A1A2E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/efe3cf72-7a15-40d9-ab18-dc5801d3c329.png" 
                alt="F&A DIGITAL" 
                className="h-14 md:h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-500 text-xs md:text-sm mb-5 md:mb-6 max-w-sm leading-relaxed">
              Especialistas en evaluación automatizada con tecnología OMR. Precisión, rapidez y confiabilidad para instituciones educativas.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#0D9488]/10 rounded-full hover:bg-[#0D9488] hover:text-white text-[#0D9488] transition-all cursor-pointer">
                <i className="ri-facebook-fill text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#0D9488]/10 rounded-full hover:bg-[#0D9488] hover:text-white text-[#0D9488] transition-all cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#0D9488]/10 rounded-full hover:bg-[#0D9488] hover:text-white text-[#0D9488] transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#0D9488]/10 rounded-full hover:bg-[#0D9488] hover:text-white text-[#0D9488] transition-all cursor-pointer">
                <i className="ri-youtube-fill text-base md:text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-bold mb-3 md:mb-4 text-[#1A1A2E]">Enlaces Rápidos</h3>
            <ul className="space-y-2 md:space-y-2.5">
              {[
                { label: 'Nosotros', id: 'about' },
                { label: 'Servicios', id: 'services' },
                { label: 'Proceso', id: 'process' },
                { label: 'Ventajas', id: 'advantages' },
                { label: 'Preguntas Frecuentes', id: 'faq' },
              ].map((item) => (
                <li key={item.id}>
                  <button onClick={() => scrollToSection(item.id)} className="text-gray-500 hover:text-[#0D9488] transition-colors text-xs md:text-sm cursor-pointer">
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm md:text-base font-bold mb-3 md:mb-4 text-[#1A1A2E]">Newsletter</h3>
            <p className="text-gray-500 text-xs md:text-sm mb-4">
              Recibe noticias y actualizaciones sobre tecnología OMR
            </p>
            <form className="flex flex-col space-y-2" data-readdy-form id="newsletter-footer">
              <input
                type="email"
                name="email"
                placeholder="Tu correo electrónico"
                className="px-3 md:px-4 py-2 md:py-2.5 rounded-lg bg-white border border-gray-200 text-[#1A1A2E] placeholder-gray-400 focus:outline-none focus:border-[#0D9488] text-xs md:text-sm"
                required
              />
              <button
                type="submit"
                className="bg-gradient-to-r from-[#0D9488] to-[#0F766E] text-white px-4 py-2 md:py-2.5 rounded-lg text-xs md:text-sm font-semibold hover:shadow-lg hover:shadow-[#0D9488]/20 transition-all whitespace-nowrap cursor-pointer"
              >
                Suscribirse
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-xs md:text-sm text-center md:text-left">
            &copy; 2026 F&amp;A DIGITAL. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <a href="#" className="text-gray-400 hover:text-[#0D9488] text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap">
              Política de Privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-[#0D9488] text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap">
              Términos de Servicio
            </a>
            <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="text-gray-400 hover:text-[#0D9488] text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}